<template>
	<el-form-item label="是否多选">
		<el-switch v-model="data.options.multiple" />
	</el-form-item>

	<el-form-item label="最大上传数">
		<el-input-number v-model="data.options.limit" :min="0" controls-position="right" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemImage',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
